import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ImageSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ImageSVG;
